import api from './client';

/** Items no admin has opened yet, shown as a pink dot and count in the sidebar. */
export interface NewCounts {
  inquiries: number;
  applications: number;
  maintenance: number;
  legal: number;
}

/** GET /api/dashboard/new-counts — admin only. */
export const getNewCounts = async (): Promise<NewCounts> => {
  const res = await api.get<{ status: number; counts: NewCounts }>('/dashboard/new-counts');
  return res.data.counts;
};

const ITEM_SEEN_EVENT = 'rentagade:item-seen';

/** Call once an item has been opened or updated, so the sidebar count refreshes. */
export const notifyItemSeen = (): void => {
  window.dispatchEvent(new Event(ITEM_SEEN_EVENT));
};

/** Run `listener` whenever an item is seen. Returns the unsubscribe function. */
export const onItemSeen = (listener: () => void): (() => void) => {
  window.addEventListener(ITEM_SEEN_EVENT, listener);
  return () => window.removeEventListener(ITEM_SEEN_EVENT, listener);
};
